import App from './App.svelte';

const app = new App({
    target: document.body,
    props: {
        name: 'world'
    }
});

export default app;

// export const tinyMCE_KEY = "iq6iq1t93pfrz9ua639vso6gdyn2r0wtxx87q4as3kgap1x4";
export const tinyMCE_KEY = "kwkxr2uxajpsfr9iifmxlqioy9004bn5qn1gg91nhbfccxfm";
